<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData">
      <div class="coupons">
        <div class="couponsInput">
          <div class="CInput line_txt1" v-if="!isCopy">{{couponText}}</div>
          <div class="CInput isCopyipt" v-if="isCopy"></div>
          <div class="Copy" :class="isCopy?'on':''" @click="CopyLink(couponText)"></div>
        </div>
        <div class="shareBox">
          <div @click="share('f')">{{$t('base.faceBook')}}</div>
          <div @click="share('t')">{{$t('base.twitter')}}</div>
        </div>
        <div class="getCoupons">{{$t('base.stepCoupons')}}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { toShare} from "@/api/public";
export default {
  name: '',
  data() {
    return {
      isCopy: false
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    couponText: String
  },
  watch: {},
  filters: {},
  created() {},
  methods: {
    share(name){
      toShare(name,this.list.Details, this.couponText)
    },
    handleClose() {
      this.$emit('closeDialog', 'coupon', false)
    },
    CopyLink(val) {
      let that = this
      this.$copyText(val).then(function(e) {
        that.isCopy = true
      }, function(e) {
        that.isCopy = false
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .coupons {
  width: 435px;
  margin-left: -20px;
}

.couponsInput {
  border: 1px solid #e0e0e0;
  background: #f0f0f0;
  padding: 0 20px;
  border-radius: 25px;
  display: flex;
}

.couponsInput .CInput {
  margin: 15px 0;
  width: 355px;
  height: 16px;
  word-break: break-all;
}

.couponsInput .isCopyipt {
  background: url(../../../static/images/icon/icon_finish_on.svg) center no-repeat;
  margin: 0;
  padding: 23px 0;
}

.couponsInput .Copy {
  padding: 15px 0;
  width: 40px;
  border-left: 1px solid #e0e0e0;
  background: url(../../../static/images/icon/icon_share.svg) center right no-repeat;
  cursor: pointer;
}

.couponsInput .Copy.on {
  background-image: url(../../../static/images/icon/icon_share_on.svg)
}

.shareBox {
  display: flex;
  justify-content: space-between;
}

.shareBox>div {
  margin-top: 28px;
  padding: 0 20px;
  height: 48px;
  line-height: 48px;
  background: #f7f7f7;
  border-radius: 32px;
  width: 45%;
  background: #f7f7f7 url(../../../static/images/Facebook.svg) 10px center no-repeat;
  padding-left: 50px;
  font-size: 16px;
}

.shareBox>div:last-child {
  background: #f7f7f7 url(../../../static/images/Twitter_pay.svg) 10px center no-repeat;
}

.shareBox>div:hover {
  background-color: #5F6DAE;
  color: #fff;
  cursor: pointer;
}

.getCoupons {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  margin-top: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/coupon.vue